import React from 'react';
import { Card } from '@/components/ui/card';
import { Users, Building2, TrendingUp, DollarSign } from 'lucide-react';

const StatCard = ({ testId, label, value, icon, tint = 'text-primary opacity-20', bg = '', valueClass = '' }) => (
  <Card className={`p-6 border border-border shadow-sm ${bg}`} data-testid={testId}>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-muted-foreground">{label}</p>
        <p className={`text-3xl font-bold mt-2 ${valueClass}`}>{value}</p>
      </div>
      {React.cloneElement(icon, { className: `w-10 h-10 ${tint}` })}
    </div>
  </Card>
);

export default function AdminStats({ stats }) {
  if (!stats) return null;
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <StatCard testId="stat-users" label="Total Users" value={stats.total_users} icon={<Users />} />
        <StatCard testId="stat-landlords" label="Landlords" value={stats.landlords} icon={<Users />} />
        <StatCard testId="stat-properties" label="Total Properties" value={stats.total_properties} icon={<TrendingUp />} tint="text-accent opacity-20" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        <StatCard
          testId="stat-platform-fees"
          label="Platform Fees Earned"
          value={`$${(stats.total_platform_fees || 0).toFixed(2)}`}
          icon={<DollarSign />}
          tint="text-primary opacity-40"
          bg="bg-primary/5"
          valueClass="text-primary"
        />
        <StatCard
          testId="stat-transaction-volume"
          label="Transaction Volume"
          value={`$${(stats.total_transaction_volume || 0).toFixed(2)}`}
          icon={<TrendingUp />}
        />
        <StatCard
          testId="stat-bookings"
          label="Paid Bookings"
          value={stats.total_bookings || 0}
          icon={<Building2 />}
          tint="text-accent opacity-20"
        />
      </div>
    </>
  );
}
